import React, {Component} from 'react';
import AccountExpenseContainer from '../../../containers/account_expense_container';
import Loader from '../../universal/loader';
import {Button, Grid, Header, Icon, Message, Popup, Segment, Image, Modal,Form} from "semantic-ui-react";
import * as hinchLogo from "../../../assets/hinchWhitebackgroundLogo.png";
import UpdateExpense from "./update_expense";

class ViewExpenseEstimate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            message: undefined,
            estimateId: undefined,
            showAdjustmentsPane: false,
            showConfirmOpen: false
        }
    }

    componentWillMount() {
        this.setState({estimateId: this.props.match.params.pipelineExpenseId});
        this.props.getEstimateDetails(this.props.match.params.pipelineExpenseId)
    }

    handleChangeStatus = () => {
        const formData = new FormData();
        formData.append("pipeline_expense_id", this.state.estimateId);
        formData.append("status", this.state.expenseStatus);
        this.props.changeExpenseEstimateStatus(formData,this.state.estimateId,this.onSuccessCallBack);
    };

    onSuccessCallBack = (response) => {
        if (response.success) {
            this.setState({message: 'Successfully changed Expense Status'});
            setTimeout(() => {
                this.setState({message: undefined})
            }, 5000)
        }
    };

    render() {
        const estimateDetail = this.props.estimateDetail;
        const mapStatus = {"submitted": 0, "approved": 1,"cancelled":3};
        let expenseStatus = [{key: 1, text: "Submitted", value: 0}, {key: 2, text: "Approved", value: 1},{key:3,text: "Cancelled",value:3}];
        if(this.props.userRole !== 'admin') {
            expenseStatus = [{key: 1, text: "Submitted", value: 0},{key:3,text: "Cancelled",value:3}];
        }
        return (<div style={{width: '80%', margin: 'auto'}}>
            {this.props.isFetching && <Loader/>}
            {!this.props.isFetching && estimateDetail && <div style={{width: '95%', margin: 'auto'}}>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={8}>
                            <Header size="large" content={"Submitted Expense"} textAlign="left"/>
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <Header size="large" content={estimateDetail['date']} textAlign="right"/>
                        </Grid.Column>
                    </Grid.Row>

                    {this.state.message && <Grid.Row>
                        <Grid.Column width={8}>

                        </Grid.Column>
                        <Grid.Column width={8}>
                            <div>
                                <Message positive content={<span className="format-bold">{this.state.message}</span>}
                                         onDismiss={() => {
                                             this.setState({message: undefined})
                                         }}/>
                            </div>
                        </Grid.Column>
                    </Grid.Row>}


                    <Grid.Row>
                        <Grid.Column width={8}>
                            <Segment style={{backgroundColor: '#249AC4', color: 'white', height: '100%'}}>
                                <div>
                                    <Grid stackable style={{marginTop: '0'}}>
                                        <Grid.Row style={{padding: '0 0 1% 0'}}>
                                            <Grid.Column width={7}>
                                                <img src={hinchLogo} alt="Hinch Property Logo"/>
                                            </Grid.Column>
                                            <Grid.Column width={9}>
                                                <div>
                                                    <div>
                                                        <p className="format-bold">Address</p>
                                                        <span>
                                                                Suite 3, First Floor Offices
                                                            </span>
                                                        <span>
                                                                East House,Chiltern Avenue,Amersham
                                                            </span>
                                                        <p>
                                                            Bucks, HP6 5AE
                                                        </p>
                                                    </div>
                                                </div>
                                            </Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row style={{textAlign: 'center'}}>
                                            <div style={{width: '50%'}}>
                                                VAT Reg No: ASD453
                                            </div>
                                            <div style={{width: '50%'}}>
                                                Terms: On Receipt
                                            </div>
                                        </Grid.Row>
                                    </Grid>
                                </div>
                            </Segment>
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <Segment style={{backgroundColor: '#F9FAFB', height: '100%'}}>
                                <div>
                                    <p className="format-bold"> </p>
                                    <dl>
                                        <dt>Name</dt>
                                        <dd>: {estimateDetail['clerk_profile_name']}</dd>
                                        <dt style={{minHeight:'75px'}}>Address</dt>
                                        <dd style={{minHeight:'75px'}}>: {estimateDetail['clerk_profile_address']}</dd>
                                        <dt>Email</dt>
                                        <dd>: {estimateDetail['clerk_profile_email']}</dd>
                                    </dl>
                                </div>
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <table width="100%" border="1" cellPadding="0" cellSpacing="0"
                                   style={{borderCollapse: 'collapse', borderColor: '#f5f5f5'}}>
                                <tbody>
                                <tr style={{backgroundColor: '#249AC4', color: 'white', height: '30px'}}>
                                    <th>Date</th>
                                    <th>Agent Ref.Id</th>
                                    <th>Property Address</th>
                                    <th>Note</th>
                                    <th>AEC</th>
                                    <th>Train</th>
                                    <th>Parking</th>
                                    <th>Fuel</th>
                                    <th>Amount</th>
                                </tr>

                                <tr>
                                    <td className="center-aligned">{estimateDetail.inspection['inspection_time']['inspection_date']}</td>
                                    <td className="center-aligned">{estimateDetail.inspection['reference_id']}</td>
                                    <td width="20%"
                                        style={{padding: '1%'}}>{estimateDetail.inspection['property_address']}</td>
                                    <td width="20%" className="format-capitalize center-aligned">{estimateDetail['notes']}</td>
                                    <td className="center-aligned">{estimateDetail['aec']}</td>
                                    <td className="center-aligned">£ {estimateDetail['train']}</td>
                                    <td className="center-aligned">£ {estimateDetail['parking']}</td>
                                    <td className="center-aligned">£ {estimateDetail['fuel']}</td>
                                    <td className="center-aligned">£ {estimateDetail['total_amount']}</td>
                                </tr>
                                </tbody>
                            </table>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                         <Grid.Column width={8}>
                             {(estimateDetail.status === "cancelled" || estimateDetail.status === "submitted") && <div className="left-aligned">
                                <Button content="Edit Expense" primary onClick={() => {
                                   this.setState({showAdjustmentsPane:true})
                                }}/>
                            </div>}
                        </Grid.Column>
                        <Grid.Column width={8}>
                            {(estimateDetail.status === "submitted" || estimateDetail.status === "cancelled") ? <Grid.Column width={8}>
                                <div style={{height: '100px'}}>
                                    <div>
                                <span className="format-bold half-wide">
                                    Expense Status :
                                </span>
                                        <span className="half-wide">
                                    <Form.Dropdown selection
                                                   placeholder="Expense Status"
                                                   fluid
                                                   options={expenseStatus}
                                                   defaultValue={mapStatus[estimateDetail.status]}
                                                   onChange={(e,option) => {
                                                       this.setState({expenseStatus:option.value })
                                                   }}
                                    />
                                </span>
                                    </div>
                                    <div className="right-aligned pad-top">
                                        <Button content="Change Status" primary onClick={() => this.handleChangeStatus()}/>
                                    </div>
                                </div>
                            </Grid.Column> : <Grid.Column width={8}>
                                <Header textAlign="center" content={<div><span>Expense has been</span><span style={{color:'green'}}> Approved</span></div>}/>
                            </Grid.Column>}
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

                <Grid>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Segment>
                                <div>
                                    <Header content="Attachments" textAlign="left"/>
                                    <Image.Group size="small">
                                        {estimateDetail['aec_attachment']['image_path'] &&  <Image as='a' label="AEC Bill" target='_blank' src={estimateDetail['aec_attachment']['image_path']} href={estimateDetail['aec_attachment']['image_path']} />}
                                        {estimateDetail['fuel_attachment']['image_path'] &&  <Image as='a' label="Fuel Bill" target='_blank' src={estimateDetail['fuel_attachment']['image_path']} href={estimateDetail['fuel_attachment']['image_path']} />}
                                        {estimateDetail['train_attachment']['image_path'] &&  <Image as='a' label="Train Bill" target='_blank' src={estimateDetail['train_attachment']['image_path']} href={estimateDetail['train_attachment']['image_path']} />}
                                        {estimateDetail['parking_attachment']['image_path'] &&  <Image as='a' label="Parking Bill" target='_blank' src={estimateDetail['parking_attachment']['image_path']} href={estimateDetail['parking_attachment']['image_path']}/>}
                                    </Image.Group>
                                    {!(estimateDetail['aec_attachment']['image_path'] && estimateDetail['fuel_attachment']['image_path'] && estimateDetail['train_attachment']['image_path'] && estimateDetail['parking_attachment']['image_path']) && <span className="info-normal format-bold">No Attachments Available</span> }
                                </div>
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Modal size="large" open={this.state.showAdjustmentsPane} onClose={(e) => {
                    this.setState({showAdjustmentsPane:false})
                }}>
                    <Modal.Content>
                        <div style={{position:'absolute',right:'10px'}}>
                            <Button basic icon negative onClick={(e) => {
                                this.setState({showAdjustmentsPane: false})
                            }}><Icon name="close"/></Button>
                        </div>
                        <Modal.Description>
                            {<UpdateExpense expenseUpdates={estimateDetail} expenseId={estimateDetail['id']} goBack={()=>{this.setState({showAdjustmentsPane:false})}}/>}
                        </Modal.Description>
                    </Modal.Content>
                </Modal>
            </div>
            }
        </div>);
    }
}

export default AccountExpenseContainer(ViewExpenseEstimate);


// WEBPACK FOOTER //
// ./src/views/accounts/expense/view_expense_estimate.js